module.exports = __webpack_public_path__ + "imgs/src/assets/imgs/pets/fitsize//green_2.png?v=6904531c";